

<template>
  <div class="contents">
      <div class="user">
        <div class="user-item">
            <img src="../assets/weimaqi_mch.png" alt="">
        </div>
        <div class="port">
            <img src="./coopera/images/cologo.png" alt="" oncontextmenu="return false;" onselectstart="return false;" class="img1">
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'Second',
}
</script>

<style scoped>
.contents{
    width:100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.user{
    width: 1200px;
	  height: 685px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    margin: 120px 0px 148px 0px;
}
.user-item{
    width: 491px;
	height: 119px;
}
.user-item>img {
    width: 100%;
}

.port{
    width: 1200px;
	height: 486px;
}
.port img{
        width: 100%;
    }
@media screen and (max-width:1024px){
    .port{
      width: 1000px;
    }
    .port img{
        width: 100%;
    }
    .contents{
        overflow-x: hidden;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/newFour.vue